import { i } from 'framer-motion/client';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AppRouter from './app/router/AppRouter';
import AdminRoutes from './app/router/AdminRoutes';

function App() {
  return (
    <Routes>
        {/* Все маршруты админки начинаются с /admin */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        
        {/* Все остальные маршруты (основной сайт) */}
        <Route path="/*" element={<AppRouter />} />
    </Routes>
  );
}

export default App;